<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="chap2" style="margin-top:20px;"><span><img alt="" src="Book1/image001.jpg"/></span></p>
<p class="center" style="margin-top:20px;"><span><img alt="" src="Book1/image002.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 7chap2.vue?0fbda241